/**
 * Val1 (28/10, ficha "Perfil: esconder Workspaces de quem só tem um"): regras puras da seção de workspaces do perfil (casca nova
 * e antiga). Um workspace só: a pessoa não vê nada sobre workspace (nem o "padrão do login"). Dois ou mais: a lista agrupada por
 * empresa (o tenant como título, os ambientes embaixo), o Sandbox com o selo "Teste".
 */
export interface WorkspaceDoPerfil {
  tenant_id: string;
  tenant_nome: string;
  workspace_id: string;
  workspace_nome: string;
  sandbox: boolean;
  padrao?: boolean;
}

/** A seção só existe com dois ou mais workspaces. */
export const mostrarWorkspaces = (workspaces: readonly unknown[]) => workspaces.length >= 2;

export interface GrupoDeWorkspaces<T extends WorkspaceDoPerfil = WorkspaceDoPerfil> {
  tenant_id: string;
  tenant_nome: string;
  itens: T[];
}

/** Agrupa por empresa (tenant), na ordem em que cada empresa aparece primeiro; os ambientes mantêm a ordem recebida. */
export function agruparWorkspaces<T extends WorkspaceDoPerfil>(workspaces: readonly T[]): GrupoDeWorkspaces<T>[] {
  const grupos = new Map<string, GrupoDeWorkspaces<T>>();
  for (const w of workspaces) {
    const g = grupos.get(w.tenant_id) ?? { tenant_id: w.tenant_id, tenant_nome: w.tenant_nome, itens: [] };
    g.itens.push(w);
    grupos.set(w.tenant_id, g);
  }
  return [...grupos.values()];
}
